import styled from 'styled-components';

export const Title = styled.h2`
  grid-area: title;
  margin: 0;
  align-self: center;
  ${(p) => p.theme.typography.title3}
  color: ${(p) => p.theme.colors.neutral.onBackground};
`;
